import rebrandColorsImport from '../rebrand/colors'

export const colors = {
  // HEDEPY COLOR SELECTION
  white: '#FFFFFF',
  beigeBg: 'var(--color-body-bg)',
  alternativeBg: '#F5F0EB',
  peach: 'var(--color-peach-500)',
  petroleum: 'var(--color-petrol-500)',
  petroleumLight: 'var(--color-petrol-300)',
  bordeaux: 'var(--color-blue-500)',
  bordeauxLight: 'var(--color-petrol-400)',
  bordeauxLighter: 'var(--color-pink-500)',

  // PREVIOUSLY USED COLORS
  primary: 'var(--color-primary)',
  secondary: 'var(--color-secondary)',
  body: 'var(--color-text-color)',
  border: '#FDF7F1',
  light: '#F1EBE5',
  lightgray: '#F1EBE5',
  dark: '#490811',
  disabled: '#BFBFBF',
}

export default {
  colors,
}

export const rebrandColors = rebrandColorsImport
